<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            Sites
            <add-button link="/sites/create"></add-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Sites</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Logo</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Address</th>
                        <th>PF NO</th>
                        <th>TAN NO</th>
                        <th>PAN NO</th>
                        <th>ESI NO</th>
                        <th>TIN NO</th>
                        <th>GST NO</th>
                        <th>Registration NO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="11"></loading-table>
                      <router-link 
                        v-for="(site, at) in sites"
                        :key="`site${at}`"
                        :to="`/sites/${site.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td><img v-if="site.logo_path" :src="mediaUrl + site.logo_path" style="width: 50px; height: 50px;" /></td>
                        <td>{{ site.name }}</td>
                        <td>{{ site.email }}</td>
                        <td>{{ site.phone }}</td>
                        <td>{{ site.address }}</td>
                        <td>{{ site.pf_no }}</td>
                        <td>{{ site.tan_no }}</td>
                        <td>{{ site.pan_no }}</td>
                        <td>{{ site.esi_no }}</td>
                        <td>{{ site.tin_no }}</td>
                        <td>{{ site.gst_no }}</td> 
                        <td>{{ site.registration_no }}</td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'sites',
  data () {
    return {
      sites: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true
      let sites = await axios.get(`/sites`)
      this.sites = sites.data.data
      this.count = sites.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
  td {
    overflow: hidden;
    white-space: nowrap;
  }
</style>